import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import serialize from 'form-serialize';
import RingSpinner from 'components/Spinner/Ring';

import './form.scss';

const ALLOW_ENTER_ELEMENTS = ['TEXTAREA'];

class CustomForm extends Component {
    static propTypes = {
        className: PropTypes.string,
        inline: PropTypes.bool,
        inProgress: PropTypes.bool,
        innerRef: PropTypes.oneOfType([
            PropTypes.shape(),
            PropTypes.node,
        ]),
        onSubmit: PropTypes.func,
        onChange: PropTypes.func,
        onInvalid: PropTypes.func,
        onKeyPress: PropTypes.func,
        tag: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
        ]),
        stopSubmitByEnter: PropTypes.bool,
    };

    static defaultProps = {
        className: undefined,
        inline: false,
        inProgress: false,
        innerRef: undefined,
        onSubmit: () => {},
        onInvalid: () => {},
        onChange: () => {},
        onKeyPress: () => {},
        tag: 'form',
        stopSubmitByEnter: false
    };

    constructor(props) {
        super(props);

        const { innerRef } = props;

        this.elForm = innerRef || React.createRef();
    }

    handleInvalid = e => {
        e.preventDefault();

        const { onInvalid } = this.props;
        onInvalid(e);
    }

    handleSubmit = e => {
        e.preventDefault();

        const { onSubmit } = this.props;

        e.formData = serialize(e.currentTarget, { hash: true });

        onSubmit(e);
    }

    handleChange = e => {
        const { onChange } = this.props;

        onChange(e);
    }

    renderInProgress() {
        const { inProgress } = this.props;

        return (
            inProgress ? (
                <div className="light-blocker">
                    <RingSpinner />
                </div>
            ) : null
        );
    }

    handleFormKeypress = e => {
        const { stopSubmitByEnter, onKeyPress } = this.props;
        const { target } = e;
        if (stopSubmitByEnter && ALLOW_ENTER_ELEMENTS.indexOf(target.nodeName) < 0) {
            e.key === 'Enter' && e.preventDefault();

        }
        onKeyPress && onKeyPress(e);
    }

    render() {
        const { className, inline, tag, children } = this.props;
        const formClass = classNames({
            'form': true,
            'inline-form': inline,
            [className]: className,
        });
        const CustomTag = tag || 'form';

        return (
            <CustomTag
                ref={ this.elForm }
                className={ formClass }
                onSubmit={ this.handleSubmit }
                onInvalid={ this.handleInvalid }
                onChange={ this.handleChange }
                onKeyPress={ this.handleFormKeypress }
            >
                { children }

                { this.renderInProgress() }
            </CustomTag>
        );
    }
}

export default CustomForm;
